var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list && _vm.list.length == 0)?_c('div',{staticClass:"text-center no-item"},[_c('br'),_c('div',[_vm._v(_vm._s(_vm.msg ? _vm.msg : 'Nenhum item encontrado'))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }